@let availableTabs = this.availableTabs();

@if (availableTabs.length > 1) {
  <div class="flex flex-col gap-5 h-full">
    <pm-tab-switch
      [tabs]="availableTabs"
      [queryKey]="DEMAND_PAGE_TAB_QUERY_KEY"
      (handleTabIdChange)="selectedTabId.set($event)"
    />

    @let tabId = this.selectedTabId();
    @if (tabId) {
      <ng-container
        *ngComponentOutlet="TAB_TO_PAGE_COMPONTENT_MAPPING[tabId]"
      />
    }
  </div>
} @else {
  <pm-forecast-version-state-handler />
}
